import app from 'flarum/forum/app';
import PostControls from 'flarum/forum/utils/PostControls';
/**
 * The forum's edit composer for `post` (PostControls.editAction), from a
 * page that isn't its discussion: EditPostButton's, and champis-keys' /keys
 * rows. A page that loaded the post without its source text - /keys only
 * asks whether it may be edited - gets it first: the composer would open
 * empty otherwise, and saving that would erase the post.
 *
 * Reached by champis-keys through flarum.reg (see index.ts), at click time.
 */
export default function editPost(post) {
  const loaded = post.content() !== undefined ? Promise.resolve(post) : app.store.find('posts', post.id());
  return loaded.then(full => PostControls.editAction.call(full));
}
flarum.reg.add('champis-forum', 'forum/utils/editPost', editPost);